import { useCallback, useRef } from "react";

/**
 * useLoadMoreOnVisible — сентинел бесконечного скролла (docs/07-miniapp-ux.md §2.2):
 * вызывает onVisible, когда возвращённый ref появляется во вьюпорте. enabled=false
 * (например, идёт загрузка или страниц больше нет) не создаёт наблюдатель вовсе.
 */
export function useLoadMoreOnVisible(onVisible: () => void, enabled: boolean) {
  const observerRef = useRef<IntersectionObserver | null>(null);

  return useCallback(
    (node: HTMLElement | null) => {
      observerRef.current?.disconnect();
      observerRef.current = null;

      if (!node || !enabled) {
        return;
      }

      const observer = new IntersectionObserver((entries) => {
        if (entries[0]?.isIntersecting) {
          onVisible();
        }
      });
      observer.observe(node);
      observerRef.current = observer;
    },
    [onVisible, enabled],
  );
}
